var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exceptions-page"},[_c('img',{attrs:{"src":_vm.exceptionsImages[`page${_vm.$route.meta.exception}`]}}),_c('div',{staticClass:"back"},[_c('span',{on:{"click":function($event){return _vm.back('home')}}},[_vm._v("返回首页")]),_c('span',{on:{"click":_vm.back}},[_vm._v("返回上一页("+_vm._s(_vm.second)+")")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }